import type { FC, ReactNode } from 'react'
import { useSwipeable, type SwipeableProps } from 'react-swipeable'

type SwipebleComponentProps = SwipeableProps & {
  children: ReactNode
  className?: string
  onRef?: (el: HTMLElement | null) => void
}

export const Swipeable: FC<SwipebleComponentProps> = ({ children, className, onRef, ...swipableProps }) => {
  const handlers = useSwipeable(swipableProps)

  const updateRef = (el: HTMLElement | null) => {
    handlers.ref(el)
    onRef?.(el)
  }

  return (
    <div className={className} ref={updateRef} key="swipable">
      {children}
    </div>
  )
}
